// extracted by mini-css-extract-plugin
export var clickable = "TallCard-module--clickable--2e0e5";
export var content = "TallCard-module--content--0b6ff";
export var cta = "TallCard-module--cta--078a8";
export var image = "TallCard-module--image--0e7bf";
export var image_wrapper = "TallCard-module--image_wrapper--99d99";
export var label = "TallCard-module--label--44f15";
export var link = "TallCard-module--link--b60ee";
export var playButton = "TallCard-module--playButton--1a677";
export var title = "TallCard-module--title--b814d";
export var wrapper = "TallCard-module--wrapper--bed39";